export default __webpack_public_path__ + "static/media/coinLogo.bbae54cf.svg";